export const permissionsSync = {
  // Track if we're currently syncing to prevent loops
  isSyncing: false,

  // Map permission types between tabs
  mapPermissionType: (permissionType, fromTab, toTab) => {
    if (fromTab === "forms" && toTab === "forms_content") {
      if (permissionType === "search_view") return "view";
      if (permissionType === "edit") return "edit";
      if (permissionType === "print") return "print"; // ADD PRINT MAPPING
      return null;
    } else if (fromTab === "forms_content" && toTab === "forms") {
      if (permissionType === "view") return "search_view";
      if (permissionType === "edit") return "edit";
      if (permissionType === "print") return "print"; // ADD PRINT MAPPING
      return null;
    }
    return null;
  },

  // Find corresponding item in Forms based on Forms Content item
  findFormsItemFromContent: (contentItemId, rawApiData) => {
    // Handle form-level IDs (like "form_11765_802")
    if (
      typeof contentItemId === "string" &&
      contentItemId.startsWith("form_")
    ) {
      const parts = contentItemId.split("_");
      const formItemId = parseInt(parts[1]); // This is the itemid from formS_TABLE

      const formsItem = rawApiData?.formS_TABLE?.find(
        (item) => item.itemid === formItemId
      );

      return formsItem;
    }

    // Handle parent group IDs (like "parent_11773")
    if (
      typeof contentItemId === "string" &&
      contentItemId.startsWith("parent_")
    ) {
      const parentItemId = parseInt(contentItemId.replace("parent_", ""));

      const formsItem = rawApiData?.formS_TABLE?.find(
        (item) => item.itemid === parentItemId
      );

      return formsItem;
    }

    // For field items, we need to find their parent form
    const fieldItem =
      rawApiData?.formS_GEN_DETAILS_TABLE?.find(
        (item) => item.itemid === contentItemId
      ) ||
      rawApiData?.formS_TABS_TABLE?.find(
        (item) => item.itemid === contentItemId
      );

    if (fieldItem) {
      // Find the form that has this alldetailsformid
      const parentForm = rawApiData?.formS_TABLE?.find(
        (item) => item.alldetailsformid === fieldItem.formid
      );

      return parentForm;
    }

    // For category-level items
    const categoryItem = rawApiData?.formS_TABLE?.find(
      (item) => item.itemid === contentItemId && item.parentitemid === null
    );

    if (categoryItem) {
      return categoryItem;
    }

    return null;
  },

  // Find corresponding item in Forms Content based on Forms item
  findContentItemFromForms: (formsItemId, formsContentPermissions) => {
    if (!formsContentPermissions?.categories) {
      return null;
    }

    // Search through all categories
    for (const category of formsContentPermissions.categories) {
      // Check if this is the category we're looking for
      if (category.id === formsItemId) {
        return { type: "category", item: category };
      }

      // Search in category items
      for (const item of category.items || []) {
        // Check for parent groups (Applications)
        if (item.isParentGroup) {
          // Check if this parent group matches
          if (item.id === `parent_${formsItemId}`) {
            return { type: "parentGroup", item, categoryId: category.id };
          }

          // Check forms under parent group
          for (const form of item.items || []) {
            if (form.id === `form_${formsItemId}_${form.formId}`) {
              return {
                type: "form",
                item: form,
                categoryId: category.id,
                parentGroupId: item.id,
              };
            }
          }
        } else {
          // Check regular forms (direct under category)
          if (item.id === `form_${formsItemId}_${item.formId}`) {
            return {
              type: "form",
              item,
              categoryId: category.id,
            };
          }
        }
      }
    }

    return null;
  },

  // Check if all fields in a form have a specific permission value
  checkAllFieldsPermission: (
    form,
    permissionType,
    updatedFieldId = null,
    updatedValue = null
  ) => {
    if (!form.items || form.items.length === 0) {
      return false;
    }

    const allChecked = form.items.every((field) => {
      // If this is the field being updated, use the new value
      if (field.id === updatedFieldId) {
        return updatedValue === true;
      }
      // Otherwise use the current value
      return field.permissions[permissionType] === true;
    });

    return allChecked;
  },

  // Check if any field in a form has a specific permission value
  checkAnyFieldPermission: (
    form,
    permissionType,
    updatedFieldId = null,
    updatedValue = null
  ) => {
    if (!form.items || form.items.length === 0) {
      return false;
    }

    const anyChecked = form.items.some((field) => {
      // If this is the field being updated, use the new value
      if (field.id === updatedFieldId) {
        return updatedValue === true;
      }
      // Otherwise use the current value
      return field.permissions[permissionType] === true;
    });

    return anyChecked;
  },

  // Set sync flag to prevent loops
  setSyncing: (value) => {
    permissionsSync.isSyncing = value;
  },

  // Check if currently syncing
  isSyncInProgress: () => {
    return permissionsSync.isSyncing;
  },
};
